<script setup lang="ts">
    import { useValidationErrors } from '@/js/composables/useValidationErrors';
    import { TriangleAlertIcon } from '@lucide/vue';

    const props = defineProps<{
        validationKey: string;
        scope?: string;
    }>();

    const v = useValidationErrors(props.scope);
</script>

<template>
    <p
        v-if="v.hasError(validationKey)"
        :id="v.errorId(validationKey)"
        role="alert"
        class="text-body text-error flex items-center mt-1.5"
    >
        <TriangleAlertIcon class="size-5 mr-1.5 self-start" />
        {{ v.errorMessage(validationKey) }}
    </p>
</template>
